import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["widget"];

  connect() {
    this.renderWidget();
  }

  disconnect() {
    this.resetWidget();
  }

  renderWidget() {
    // Wait for Turnstile to be available since it loads async
    const tryRender = () => {
      if (window.turnstile && this.hasWidgetTarget) {
        try {
          // Reset any existing widget first
          this.resetWidget();

          // Render the widget
          window.turnstile.render(this.widgetTarget);
        } catch (error) {
          console.error("Failed to render Turnstile widget:", error);
        }
      } else if (!window.turnstile) {
        // Turnstile not ready yet, try again in 100ms
        setTimeout(tryRender, 100);
      }
    };

    tryRender();
  }

  resetWidget() {
    if (window.turnstile && this.hasWidgetTarget) {
      try {
        window.turnstile.reset(this.widgetTarget);
      } catch (error) {
        // Reset might fail if widget wasn't rendered, that's ok
      }
    }
  }
}
